import { destinationAtom } from 'data/Atom/Search';
import { searchStore } from 'data/Atom/Store';

import Console from 'utility/Debug/Console';
import { dispatchStatsDEvent } from 'utility/Track/statsD';
import { trackGa4Event } from 'utility/Track/trackingHelper';
import { EventParamListGa4 } from 'utility/Track/types';

import { Destination, DirectSearchType } from 'types/Search/form';
import { notSet } from 'types/tracking';

import { ResponseStatus } from 'proto/Api/ResponseStatus';

import { HotelListView } from '../../component/Accommodation/List/__partials/List/types';

enum PreviousPage {
    S3 = 'S3',
    S4 = 'S4',
    Direct = 'direct',
}

export const getDestinationId = (destination: Destination) => {
    switch (destination?.directSearch) {
        case DirectSearchType.Hotel:
        case DirectSearchType.Region:
            return [...destination.regionIdList][0];
        case DirectSearchType.City:
            return [...destination.cityIdList][0];
        case DirectSearchType.Country:
            return [...destination.countryIdList][0];
        case DirectSearchType.RegionGroup:
            return [...destination.regionGroupIdList][0];
        case DirectSearchType.CtsDestination:
            return destination.ctsDestination;
    }
};

export const trackNoResult = (isInitialSearch: boolean) => {
    const referrer = window.document.referrer;
    const currentPage = window.location.href;
    const referrerIsStep3 = referrer.indexOf('/suche/hotel') > -1;
    const referrerIsStep4 = referrer.indexOf('/suche/angebot') > -1;
    const previousPage =
        !isInitialSearch || referrerIsStep3
            ? PreviousPage.S3
            : referrerIsStep4
            ? PreviousPage.S4
            : PreviousPage.Direct;

    const trackingReferer =
        previousPage === PreviousPage.Direct ? referrer : notSet;
    const destination = searchStore.get(destinationAtom);
    const destinationId = getDestinationId(destination) || notSet;

    const eventParamList: EventParamListGa4 = {
        region_id: destinationId,
        region_name: destination.label,
        previous_step: previousPage,
        url: currentPage,
        previous_url: trackingReferer,
    };
    Console.info('event data noResult_impression', eventParamList);
    trackGa4Event('noResult_impression', eventParamList);
};

export function trackStatsDHotelList(
    status: ResponseStatus,
    view: HotelListView
) {
    switch (status) {
        case ResponseStatus.Success:
            dispatchStatsDEvent('hotellist.success');
            break;
        case ResponseStatus.Error:
            dispatchStatsDEvent('hotellist.error');
            break;
        case ResponseStatus.Empty:
            dispatchStatsDEvent('hotellist.noresult');
            break;
        case ResponseStatus.Timeout:
            if (view === HotelListView.ResultList) {
                dispatchStatsDEvent('hotellist.partial_timeout');
            } else {
                dispatchStatsDEvent('hotellist.timeout');
            }
            break;
    }
}
